import axios, { AxiosResponse } from 'axios';

const prepareFileLei = (fileName: string, varsymb: string) => {
    return axios({
        method: 'GET',
        url: `LEI/Download/Prepare?varsym=${varsymb}&file=${fileName}`
    })
        .then((resp: AxiosResponse<{ redirect: string }>) => resp.data)
        .catch(() => {
            return {
                redirect: ''
            };
        });
};

export default prepareFileLei;
